import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "zxhj-file-list"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  key: 0,
  class: "delete"
};
var _hoisted_4 = {
  key: 0,
  class: "empty"
};
import { ref, watch } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import FilePreviewDialog from './FilePreviewDialog.vue';
import { getFileType } from '../utils/';

// 佐证文件列表 显示组件

export default {
  __name: 'FileList',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:value', 'delete'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var fileList = ref([]);
    watch(function () {
      return props.value;
    }, function (val) {
      if (val) {
        fileList.value = val || [];
        emit('update:value', val);
      }
    }, {
      immediate: true
    });

    // 文件预览
    var filePreviewShow = ref(false);
    var filePreviewPath = ref('');
    var handlePreviewFile = function handlePreviewFile(path) {
      filePreviewPath.value = path;
      filePreviewShow.value = true;
    };

    // 删除文件
    var handleDeleteFile = function handleDeleteFile(index) {
      fileList.value.splice(index, 1);
      emit('delete', fileList.value);
      MessagePlugin.success('删除成功');
    };
    return function (_ctx, _cache) {
      var _fileList$value;
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_empty = _resolveComponent("empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, function (item, index) {
        var _unref2;
        return _openBlock(), _createElementBlock("div", {
          key: item.url,
          class: "list-item"
        }, [_createElementVNode("div", {
          class: "info",
          onClick: function onClick($event) {
            return handlePreviewFile(item.url);
          }
        }, [_createVNode(_component_svg_icon, {
          class: "file-icon",
          name: (_unref2 = _unref(getFileType)(item.url)) === null || _unref2 === void 0 ? void 0 : _unref2.icon,
          size: "40"
        }, null, 8, ["name"]), _createElementVNode("p", null, _toDisplayString(item.name || '未命名文件'), 1)], 8, _hoisted_2), !props.readonly ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_svg_icon, {
          size: "16",
          name: "delete",
          onClick: function onClick($event) {
            return handleDeleteFile(index);
          }
        }, null, 8, ["onClick"])])) : _createCommentVNode("", true)]);
      }), 128)), !((_fileList$value = fileList.value) !== null && _fileList$value !== void 0 && _fileList$value.length) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_empty, {
        text: "暂无佐证材料",
        imageSize: 65
      })])) : _createCommentVNode("", true), _createVNode(FilePreviewDialog, {
        visible: filePreviewShow.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return filePreviewShow.value = $event;
        }),
        path: filePreviewPath.value
      }, null, 8, ["visible", "path"])]);
    };
  }
};